module.exports = __webpack_public_path__ + "static/img/function02.33390965.png";